// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, cloneElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import { unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer, unmountComponentAtNode } from 'react-dom';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Tooltip.less';

/**
 * Tooltip component.
 */
class Tooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            left: 0,
            top: 0,
        };
    }

    componentDidUpdate() {
        if (this.node) {
            renderSubtreeIntoContainer(
                this,
                this.renderTooltip(),
                this.node,
            );
        }
    }

    componentWillUnmount() {
        this.handleHide();
    }

    handleShow = () => {
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }

        this.node = document.createElement('div');
        document.body.appendChild(this.node);

        renderSubtreeIntoContainer(
            this,
            this.renderTooltip(),
            this.node,
        );
    };

    handleHide = () => {
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }
        if (this.node) {
            unmountComponentAtNode(this.node);
            document.body.removeChild(this.node);
            this.node = null;
        }
    };

    handleMouseEnter = () => {
        if (this.showTimer || this.node) {
            return;
        }
        this.showTimer = setTimeout(this.handleShow, this.props.delay);
    };

    handleMouseMove = e => {
        const tooltipPosition = this.getTooltipPosition(e);
        const tooltipOffset = this.getTooltipOffset();

        this.setState({
            left: tooltipPosition.x + tooltipOffset.x,
            top: tooltipPosition.y + tooltipOffset.y,
        });
    };

    handleMouseLeave = () => {
        this.handleHide();
    };

    getTooltipPosition(e) {
        const x = e.clientX + (window.scrollX || window.pageXOffset);
        const y = e.clientY + (window.scrollY || window.pageYOffset);

        return { x, y };
    }

    getTooltipOffset() {
        const x = 5;
        const y = 13;

        return { x, y };
    }

    renderTooltip() {
        const { baseClassName, className, children, title, style, ...props } = this.props;
        const { left, top } = this.state;

        return (
            <span
                className={classNames(baseClassName, className)}
                style={{ ...style, left: `${left}px`, top: `${top}px` }}
                role="tooltip"
                {...props}
            >
                {title}
            </span>
        );
    }

    render() {
        return cloneElement(this.props.children, {
            onMouseEnter: this.handleMouseEnter,
            onMouseMove: this.handleMouseMove,
            onMouseLeave: this.handleMouseLeave,
        });
    }
}
Tooltip.propTypes = {
    /**
     * Content of the tooltip
     */
    title: PropTypes.node.isRequired,
    /**
     * Show delay (ms)
     */
    delay: PropTypes.number,
    /**
     * Element with tooltip
     */
    children: PropTypes.element.isRequired,
    /**
     * @ignore
     */
    style: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Tooltip.defaultProps = {
    delay: 550,
    style: undefined,
    className: undefined,
    baseClassName: `${CLS_PREFIX}tooltip`,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./components/Tooltip/Tooltip.js